import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgPlay = () => {
    return (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.1749 15.15V14.45L8.575 8L8 8.45V21.15L8.575 21.55L24.1749 15.15Z" }, void 0) }), void 0));
};
//# sourceMappingURL=play.js.map
